import loadScript from 'helpers/loadScript'

const chartJS = async () => loadScript('https://cf.nearpod.com/libs/chart.js-2.9.3/Chart.bundle.min.js')

export function isChartLibraryLoaded() {
	return !!window.Chart
}

export default function(element, settings) {
	return window.Chart ?
		new window.Chart(element, settings) :
		{
			destroy: () => {},
		}
}

export {
	chartJS,
}
